import type { RequestFn } from '../client';

export class AnalyticsDashboard {
  constructor(private readonly request: RequestFn) {}

  /** Get analytics dashboard data. `GET /analytics-dashboard` */
  async retrieve(
    params?: Record<string, string | number | undefined>,
  ): Promise<Record<string, unknown>> {
    return this.request('GET', '/analytics-dashboard', { query: params });
  }

  /** Generate analytics dashboard report. `POST /analytics-dashboard` */
  async generate(params: Record<string, unknown>): Promise<Record<string, unknown>> {
    return this.request('POST', '/analytics-dashboard', { body: params });
  }
}
